<template>
    <div class="container">
        <el-table  ref="multipleTable" @row-click="clickRow"  :data="data" header-cell-class-name="header-cell-style" 
            header-row-class-name="header-row-style" cell-class-name="cell-style" row-class-name="row-style"
             style="width: 100%" @selection-change="handleSelectionChange" height="66vh">
             <el-table-column
                type="selection"
                width="55"  v-if="$route.params.classify=='unconfirmed'">
            </el-table-column>
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="event_name" label="等级">
                 <template slot-scope="scope">
                    <span v-if="scope.row.event_name=='过流'" style="color:#DE0808">紧急</span>
                    <span v-else-if="scope.row.event_name=='过压'" style="color:#F5AA00">隐患</span>
                    <span v-else style="color:#0D94FF">通知</span>
                </template>
            </el-table-column>
            <el-table-column prop="area_name" label="位置"></el-table-column>
            <el-table-column prop="event_name" label="事件名称"></el-table-column>
            
            <el-table-column prop="event_name" label="事件类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.event_name=='过流'" >保护动作</span>
                    <span v-else-if="scope.row.event_name=='过压'">越限异常</span>
                    <span v-else>信息通报</span>
                </template>
            </el-table-column>
        
            <el-table-column prop="start" label="发生时间">
                <template slot-scope="scope">
                    <span>{{scope.row.start_time | dateformat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="end" label="结束时间">
                <template slot-scope="scope">
                    <span>{{scope.row.end_time | dateformat}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="check" label="报警确认">
                <template slot-scope="scope">
                    <span v-if="$route.params.classify=='unconfirmed'">{{scope.row.check | status}}</span>
                    <span v-else-if="$route.params.classify=='Historical'">已确认</span>
                </template>
            </el-table-column>
            <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                    <!--size="small"-->
                    <el-button @click.stop="handleClick(scope.row, '查看')" type="text">查看</el-button>
                    <el-button v-if="$route.params.classify=='unconfirmed'" @click.stop="handleClick(scope.row, '确认')" type="text"  
                        :disabled="scope.row.check ? true : false" >确认</el-button>
                </template>
            </el-table-column>

            <template v-slot:empty >
                <img class="empty-img" :src="require('../../../assets/img/not_found_data.png')">
            </template>
        </el-table>
        <div class="pagination" v-if="ListInfo.total>0">
            <div @click="$emit('handleCurrentChange', 1)" :class="{disabled:ListInfo.current==1}" class="curr">首页</div>
            <div class="page">
                <el-pagination
                    :current-page.sync="ListInfo.current"
                    @current-change="handleCurrentChange"
                    :page-size="10"
                    :pager-count="3" 
                    prev-text="上一页"
                    next-text="下一页"
                    layout="prev, pager, next"
                    :total="ListInfo.total">
                </el-pagination>
            </div>
            <div @click="$emit('handleCurrentChange', ListInfo.pages)" :class="{disabled:ListInfo.current==ListInfo.pages}" class="curr">尾页</div>
            <div class="total">每页<span>{{ListInfo.size}}</span>条/共<span>{{ListInfo.total}}</span>条</div>
        </div>
        
    </div>
</template>

<script>
    import {
        dateFormat
    } from '../../../util/DateUtil';

    export default {
        props: {
            data: Array,
            ListInfo:Object,
            isClear:Boolean
        },
        data(){
            return {

            }
        },
        methods: {
            clickRow(row){
                this.$refs.multipleTable.toggleRowSelection(row)
            }, 
            handleSelectionChange(val){
                this.$emit('handleSelectionChange',val)
            },
            handleCurrentChange(val){
                this.$emit('handleCurrentChange', val);
            },
            handleClick(row, value) {
                if (value == '查看') {
                    this.$emit('showDetail', row.id);
                } else if (value == '确认') {
                    this.$emit('setCheck', row.id)
                }
            },
        },
        watch:{
            isClear(n,o){
                this.$refs.multipleTable.clearSelection();
                this.$emit('isClear',false)
            }
        },
        filters: {
            dateformat: function (value) {
                if (!value) {
                    return '--';
                }
                return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
            },
            mapper: function (value) {
                return TYPES[value] || '未知事件';
            },
            status: function (value) {
                return value ? '已确认' : '未确认'
            }
        }
    }
</script>

<style lang="less" scoped>
    /deep/.header-row-style{
        th{
            height: 64rem;
        }
    }
    .empty-img{
        margin-top: 20%;
    }
    /deep/ .el-table td{
        border: 0 ;
    }
    /deep/.el-table::before{
        height: 0;
    }
    
    /deep/ .el-pagination{
        font-weight: 400;
        padding:0;
       .btn-prev,.btn-next{
            width: 67rem;
            height: 31rem;
            line-height: 31rem;
            border: 1px solid #999999;
            border-radius: 2px;
            padding: 0 !important;
            text-align: center;
            font-size: 18rem !important;
            margin: 0 5px;
            span{
                font-size: 18rem !important;
                line-height: 31rem;
            }
        }
        :disabled{
            color: #CCCCCC;
            border:1px solid rgba(0, 0, 0, 0.15);
        }
        .btn-next{
            margin-left: 10px;
        }
        .el-pager li{
             font-size: 18rem !important;
        }
    }
    .pagination{
        overflow: hidden;
        line-height: 31rem;
        border-top: 1px solid #E5E5E5;
        position: absolute;
        bottom: 0;
        .h(70);
        width: 100%;
        padding: 16px 24px;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        font-size: 18rem;
        .curr{
            cursor: pointer;
        }
        .disabled{
            color: #CCCCCC;
            cursor:no-drop;
        }
        .total{
            margin-left: 70rem;
            span{
                color: #0D94FF;
            }
        }
        .page{
            margin:0 10rem;
        }
    }
    .container {
        height: 100%;
        overflow: hidden;
        // display: flex;
        justify-content: center;
        align-items: center;
        //火狐隐藏滚动条
        scrollbar-width: none;

        .center {
            text-align: center;
            line-height: 48rem;
            height: 48rem;
        }
    }
</style>